import React from 'react';
import ReactDOM from 'react-dom';

class WidgetListSidebar extends React.Component {
    constructor() {
        super();
        this.state = {
            isBaseLayerOpen: true,
            widgetFPS: null,
            widgetBaseLayer: null,
            widgetSatellite: null,
            widgetTimeline: null,
            widgetTimelinePlayer: null,
            widgetDTM: null,
            widgetSensorThings: null,
            widgetWeather: null,
            widgetPipeline: null,
            widgetTrack: null,
            widgetSeaBed: null
        };
        this.sidebarSwitch = this.sidebarSwitch.bind(this);
        this.showFPS = this.showFPS.bind(this);
        this.showBaseLayer = this.showBaseLayer.bind(this);
        this.showSatellite = this.showSatellite.bind(this);
        this.showDTM = this.showDTM.bind(this);
        this.showSensorThings = this.showSensorThings.bind(this);
        this.showWeather = this.showWeather.bind(this);
        this.showPipeline = this.showPipeline.bind(this);
        this.showTrack = this.showTrack.bind(this);
        this.showSeaBed = this.showSeaBed.bind(this);
    }
    sidebarSwitch(){
        this.props.setWidgetListOpen();
    }
    showFPS() {
        let widgetFPS = this.state.widgetFPS;
        if (widgetFPS !== null) {
            widgetFPS.remove();
        }
        widgetFPS = new window.ov.Widget.FPS({
            view: window.main.OView,
            style: { left: "90px", width: "100px" }
        });
        this.setState({ widgetFPS });
    }
    showBaseLayer() {
        let widgetBaseLayer = this.state.widgetBaseLayer;
        if (widgetBaseLayer === null) {
            widgetBaseLayer = new window.ov.Widget.BaseMap({
                view: window.main.OView,
                listX: 100,
                iconX: 100,
                iconWidth: 32,
                iconHeight: 32
            });
            this.setState({widgetBaseLayer});
        } else {
            let isOpen = this.state.isBaseLayerOpen;
            if (isOpen) {
                widgetBaseLayer.hide();
            } else {
                widgetBaseLayer.show();
            }
            this.setState({isBaseLayerOpen: !isOpen});
        }
        this.sidebarSwitch();
    }
    showSatellite() {
        let widgetSatellite = this.state.widgetSatellite;
        let widgetTimeline = this.state.widgetTimeline;
        let widgetTimelinePlayer = this.state.widgetTimelinePlayer;
        if (widgetSatellite === null) {
            let terrainview = window.main.OView;
            terrainview.getModule("military");
            widgetTimeline = new window.ov.Widget.Timeline({
                view: terrainview,
                style: { left: "160px", width: "77%", bottom: "30px" },
                startTime: new Date().getTime(),
                stopTime: new Date().getTime() + 86400000,
                isRepeat: true
            });
            let widgetTimelinePlayer = new window.ov.Widget.TimelinePlayer({
                view: terrainview,
                timeline: widgetTimeline,
                playSpeed: 10000.0,
                style: {left: "100px", bottom: "30px"}
            });
            let list = [16613,20436,22823,25260,27421,38755,40053,44586,44587,28254,42920,38012,39019,33331,35946]; 
            let widgetSatellite = new window.ov.Widget.SatelliteWidget({
                view: terrainview,
                timeline: widgetTimeline,
                list: list,
                apiKey: "3XFHAJ-RLL9CP-5XWQ2G-4TX9",
                proxy: window.LOCAL_SERVER.URLTemplate
            });
            this.setState({widgetSatellite, widgetTimeline, widgetTimelinePlayer});
        } else {
            widgetSatellite.remove();
            widgetTimeline.remove();
            widgetTimelinePlayer.remove();
            this.setState({widgetSatellite: null, widgetTimeline: null, widgetTimelinePlayer: null});
        }
    }
    showDTM() {
        let widgetDTM = this.state.widgetDTM;
        if (widgetDTM !== null) {
            widgetDTM.remove();
        }
        widgetDTM = new window.ov.Widget.DTM({view: window.main.OView, proxy: "dtm.ashx?" });
        document.querySelectorAll(".ov-widget-DTM input[name='apikey']")[0].value = "fa0cecdf-4ea2-420e-b0eb-69a684d5af48";
        document.querySelectorAll(".ov-widget-DTM .ov-widget-inputContainer")[0].setAttribute('hidden', true);
        document.querySelectorAll(".ov-widget-DTM .ov-widget-divider")[2].setAttribute('hidden', true);
        this.setState({widgetDTM});
    }
    showSensorThings() {
        let widgetSensorThings = this.state.widgetSensorThings;
        if (widgetSensorThings !== null) {
            widgetSensorThings.remove();
        }
        widgetSensorThings = new window.ov.Widget.SensorThings({view: window.main.OView, proxy: "sensorthings.ashx?"});
        this.setState({widgetSensorThings});
    }
    showWeather(){
        let widgetWeather = this.state.widgetWeather;
        if (widgetWeather !== null) {
            widgetWeather.remove();
        }
        widgetWeather = new window.ov.Widget.Weather({
            view: window.main.OView,
            proxy: window.LOCAL_SERVER.URLTemplate,
            authorization: "CWB-37D2C858-E377-4B2C-94C5-FA38AA2DB521"
        });
        this.setState({ widgetWeather });
    }
    showPipeline()
    {
        let widgetPipeline = this.state.widgetPipeline;
        if (widgetPipeline !== null) {
            widgetPipeline.remove();
        }
        widgetPipeline = new window.ov.Widget.Pipeline({
            view: window.main.OView,
            proxy: window.LOCAL_SERVER.URLTemplate,
            list: [
                {
                    url: "http://127.0.0.1:8080",
                    identifier: "TaichungPipeline"
                },
                {
                    url: "http://127.0.0.1:8080",
                    identifier: "TaichungManHole"
                },
                {
                    url: "http://127.0.0.1:8080",
                    identifier: "TaichungEquipment"
                }
            ]
        });
        this.setState({ widgetPipeline });
    }
    showTrack()
    {
        let widgetTrack = this.state.widgetTrack;
        let widgetTimeline = this.state.widgetTimeline;
        let widgetTimelinePlayer = this.state.widgetTimelinePlayer;

        if (widgetTrack === null)
        {
            let widgetTimeline = new window.ov.Widget.Timeline({
                view: window.main.OView,
                style: { left: "160px", width: "77%", bottom: "30px" }                
            });

            let widgetTimelinePlayer = new window.ov.Widget.TimelinePlayer({
                view: window.main.OView,
                timeline: widgetTimeline,
                playSpeed: 500.0,
                style: { left: "100px", bottom: "30px" }
            });

            let widgetTrack = new window.ov.Widget.TrackWidget({
                view: window.main.OView,
                timeline: widgetTimeline,
                proxy: window.LOCAL_SERVER.URLTemplate
            });

            this.setState({ widgetTrack, widgetTimeline, widgetTimelinePlayer });
        }
        else
        {
            widgetTrack.remove();
            widgetTimeline.remove();
            widgetTimelinePlayer.remove();
            this.setState({ widgetTrack: null, widgetTimeline: null, widgetTimelinePlayer: null });
        }
    }
    showSeaBed()
    {
        let widgetSeaBed = this.state.widgetSeaBed;
        if (widgetSeaBed !== null) {
            widgetSeaBed.remove();
        }
        widgetSeaBed = new window.ov.Widget.SeaBed({
            view: window.main.OView,
            layerParam: {
                url: "http://127.0.0.1:8080/wmts",
                identifier: "NTU_Space_contour",
                layername: "SeabedLine",
                urlTemplate: "https://sample.pilotgaea.com.tw/Oview.aspx?{URL}"
            },
            currentSrc: "https://sample.pilotgaea.com.tw/demo/index/src/testweb/sea/SADCP_std.csv"
//            proxy: window.LOCAL_SERVER.URLTemplate,
        });
        this.setState({ widgetSeaBed });
    }
    showHouseDisplay() {
        let widgetHouseDisplay = new window.ov.Widget.ReadilyAvailableHouseDisplay({
            view: window.main.OView,
            urlTemplate: window.TERRAIN_SERVER.URLTemplate
        });
        widgetHouseDisplay._WidgetUI._PosX = 145;
        let widget = document.querySelectorAll(".ov-widget-corner");
        widget[widget.length - 1].style.left = "145px";
        this.sidebarSwitch();
        let widgetContent = document.getElementsByClassName("ov-widget-readilyAvailableHouse-content");
        let widgetFile = document.querySelectorAll(".ov-widget-readilyAvailableHouse-content .example-file");
        Object.keys(widgetFile).forEach((key) => {
            widgetFile[key].remove();
        });
        Object.keys(widgetContent).forEach((key) => {
            if (widgetContent[key].childElementCount == 3) {
                let a = document.createElement("a");
                a.className = "example-file";
                a.href = "src/ReadilyAvailableHouse.zip";
                a.text = "範例檔案";
                widgetContent[key].prepend(a);
            }
        });
    }
    showHouseInspection() {
        let widgetHouseInspection = new window.ov.Widget.ReadilyAvailableHouseInspection({
            view: window.main.OView,
            urlTemplate: window.TERRAIN_SERVER.URLTemplate
        });
        widgetHouseInspection._WidgetUI._PosX = 145;
        let widget = document.querySelectorAll(".ov-widget-corner");
        widget[widget.length - 1].style.left = "145px";
        this.sidebarSwitch();
        let widgetContent = document.getElementsByClassName("ov-widget-readilyAvailableHouse-content");
        let widgetFile = document.querySelectorAll(".ov-widget-readilyAvailableHouse-content .example-file");
        Object.keys(widgetFile).forEach((key) => {
            widgetFile[key].remove();
        });
        Object.keys(widgetContent).forEach((key) => {
            if (widgetContent[key].childElementCount == 3) {
                let a = document.createElement("a");
                a.className = "example-file";
                a.href = "src/ReadilyAvailableHouse.zip";
                a.text = "範例檔案";
                widgetContent[key].prepend(a);
            }
        });
    }
    showOGCLayer() {
        let widgetOGCLayer = new window.ov.Widget.OGCLayer({
            view: window.main.OView,
            urlTemplate: "{URL}"
        });
        widgetOGCLayer._WidgetUI._PosX = 145;
        let widget = document.querySelectorAll(".ov-widget-corner");
        widget[widget.length - 1].style.left = "145px";
        this.sidebarSwitch();
        let widgetContent = document.getElementsByClassName("ov-widget-ogcLayer-addOGCLayerContainer")[0];
        let widgetUrl = document.querySelector(".ov-widget-ogcLayer-addOGCLayerContainer .example-url");
        if (widgetUrl != null) {
            widgetUrl.remove();
        }
        let a = document.createElement("a");
        a.className = "example-url";
        a.href = "https://3dmaps.nlsc.gov.tw/";
        a.target = "_blank";
        a.text = "介接服務說明";
        widgetContent.prepend(a);
        document.getElementsByClassName("ov-widget-ogcLayer-urlText")[0].value = "https://i3s.nlsc.gov.tw/building/i3s/SceneServer/layers/13";
        
        window.main.OView.gotoCamera(new window.ov.Camera(
            new window.GeoPoint(120.99656009774225, 24.782068349516408, 154.4618651421146),
            new window.Geo3DPoint(-0.8451241062117226, 0.3666476115084564, -0.3890177040636856),
            new window.Geo3DPoint(-0.35687954156487384, 0.15482818505500448, 0.9212302784456332)
        ), false); // NCHC
    }
    showSocioeconomic() {
        let widgetSocioeconomic = new window.ov.Widget.Socioeconomic({
            view: window.main.OView,
            urlTemplate: window.TERRAIN_SERVER.URLTemplate
        });
        widgetSocioeconomic._WidgetUI._PosX = 145;
        let widget = document.querySelectorAll(".ov-widget-corner");
        widget[widget.length - 1].style.left = "145px";
        this.sidebarSwitch();
        let widgetContent = document.querySelector("[id^='Socioeconomic']").parentElement.parentElement;
        widgetContent.classList.add("ov-widget-Socioeconomic-content");
        let widgetFile = document.querySelector(".ov-widget-Socioeconomic-content .example-file");
        if (widgetFile != null) {
            widgetFile.remove();
        }
        let a = document.createElement("a");
        a.className = "example-file";
        a.href = "src/Socioeconomic.zip";
        a.text = "範例檔案(EPSG:4326)";
        widgetContent.prepend(a);
    }
    showKML() {
        let widget = new window.ov.Widget.KML({
            view: window.main.OView
        });
        widget._WidgetUI._PosX = 145;
        document.querySelector(".ov-widget-KML-ui").style.left = "145px";
        this.sidebarSwitch();
        let widgetContent = document.getElementsByClassName("ov-widget-KML-content")[0];
        let widgetFile = document.querySelector(".ov-widget-KML-content .example-file");
        if (widgetFile != null) {
            widgetFile.remove();
        }
        let a = document.createElement("a");
        a.className = "example-file";
        a.href = "src/省道陡坡圖資KML_11203.zip";
        a.style.display = "block";
        a.text = "範例檔案";
        widgetContent.prepend(a);
    }
    showMultiWindow() {
        let currentview = window.main.OView;
        let widgetMultiWindow = new window.ov.Widget.MultiWindow({
            view: window.main.OView,
            urlTemplate: window.TERRAIN_SERVER.URLTemplate
        });
        widgetMultiWindow.addEventListener("load", (index) => {
            let view = widgetMultiWindow.getSubTerrainView(index);
            let url = "https://wmts.nlsc.gov.tw/wmts";
            let identifier = "PHOTO2";
            switch (index) {
                case 1:
                    identifier = "EMAP5";
                    break;
                case 2:
                    identifier = "PHOTO2";
                    break;
                case 3:
                    identifier = "EMAP5";
                    break;
                default:
                    break;
            }
            view.setBaseLayer({
                url: url,
                identifier: identifier,
                urlTemplate: "{URL}"
            });
        });
        widgetMultiWindow.addEventListener("focus", (index) => {
            let view = widgetMultiWindow.getSubTerrainView(index);
            currentview = view;
        });
        widgetMultiWindow._WidgetUI._PosX = 145;
        document.querySelector(".ov-widget-multiWindow-main").style.left = "145px";
        this.sidebarSwitch();
        let widgetContent = document.querySelector(".ov-widget-multiWindow-contentDiv");
        if (document.getElementsByClassName("map-list")[0] != undefined) {
            document.getElementsByClassName("map-list")[0].remove();
        }
        let mapList = document.createElement("div");
        mapList.className = "map-list";
        mapList.innerHTML = '<h6>選擇圖資</h6><ul><li><a id="baseNLSCPhoto2">切換底圖：正射影像</a></li><li><a id="baseNLSCEMap5">切換底圖：電子地圖</a></li><li><a id="modelSetTaipei">加入傾斜攝影模型：台北市</a></li><li><a id="overlayLandUsed">加入圖層：國土利用調查現況成果圖</a></li><li><a id="overlayGeology">加入圖層：地質敏感(山崩與地滑)</a></li><li><a id="overlaySchoolRegion">加入圖層：各級學校範圍圖</a></li></ul>';
        widgetContent.append(mapList);
        document.getElementById("baseNLSCPhoto2").addEventListener("click", () => {
            currentview.setBaseLayer({
                url: "https://wmts.nlsc.gov.tw/wmts",
                identifier: "PHOTO2",
                urlTemplate: "{URL}"
            });
        });
        document.getElementById("baseNLSCEMap5").addEventListener("click", () => {
            currentview.setBaseLayer({
                url: "https://wmts.nlsc.gov.tw/wmts",
                identifier: "EMAP5",
                urlTemplate: "{URL}"
            });
        });
        document.getElementById("modelSetTaipei").addEventListener("click", () => {
            currentview.addOGCI3SLayer({
                url: "https://i3s.nlsc.gov.tw/building/i3s/SceneServer/layers/0",
                urlTemplate: "{URL}"
            });
        });
        document.getElementById("overlayLandUsed").addEventListener("click", () => {
            currentview.addTerrainWMTSOverlay({
                url: "https://wmts.nlsc.gov.tw/wmts",
                identifier: "LUIMAP",
                urlTemplate: "{URL}"
            });
        });
        document.getElementById("overlayGeology").addEventListener("click", () => {
            currentview.addTerrainWMTSOverlay({
                url: "https://wmts.nlsc.gov.tw/wmts",
                identifier: "GeoSensitive2",
                urlTemplate: "{URL}"
            });
        });
        document.getElementById("overlaySchoolRegion").addEventListener("click", () => {
            currentview.addTerrainWMTSOverlay({
                url: "https://wmts.nlsc.gov.tw/wmts",
                identifier: "SCHOOL",
                urlTemplate: "{URL}"
            });
        });
    }
    showBuildingOverlay() {
        let modelName = "nangang";
        let modelSet = window.main.OView.findLayer(modelName);
        if (modelSet == null) {
            window.main.OView.addModelSetLayer({
                url: window.LOCAL_SERVER.URL,
                identifier: "nangang",
                urlTemplate: window.TERRAIN_SERVER.URLTemplate,
                callback: (success, layer) => {
                    if (success) {
                        modelSet = layer;
                        layer.goto();
                    }
                }
            });
        }
        let buildingOverlay = new window.ov.Widget.BuildingOverlay({
            view: window.main.OView,
            options: [{
                text: "國土利用現況調查成果圖",
                value: {
                    url: "https://wmts.nlsc.gov.tw/wmts",
                    identifier: "LUIMAP",
                    layername: "LUIMAP_cover"
                }
            }, {
                text: "土壤液化潛勢_中級",
                value: {
                    url: "https://wmts.nlsc.gov.tw/wmts",
                    identifier: "SoilLiquefaction2",
                    layername: "SoilLiquefaction2_cover"
                }
            }],
            buildingLayer: {
                name: "nangang"
            },
            urlTemplate: "{URL}"
        });
        buildingOverlay._WidgetUI._PosX = 145;
        document.querySelector(".ov-widget-BuildingOverlay-main").style.left = "145px";
        this.sidebarSwitch();

        let widgetContent = document.querySelector(".ov-widget-BuildingOverlay-contentDiv");
        let legendUrl = "https://maps.nlsc.gov.tw/demo/109%E5%B9%B4%E7%89%88%E5%9C%8B%E5%9C%9F%E5%88%A9%E7%94%A8%E8%89%B2%E7%A2%BC%E8%A1%A8.png";
        let a = document.createElement("a");
        a.className = "ov-widget-BuildingOverlay-v-center legend";
        a.href = legendUrl;
        a.target = "_blank";
        a.text = "圖例";
        widgetContent.append(a);
        document.querySelector(".ov-widget-select.ov-widget-inputItem").addEventListener("change", (e) => {
            let selectedObj = JSON.parse(e.target.value);
            let legend = document.querySelector(".ov-widget-BuildingOverlay-v-center.legend");
            if (legend != null) {
                legend.remove();
            }
            if (selectedObj.id == "LUIMAP") {
                let a = document.createElement("a");
                a.className = "ov-widget-BuildingOverlay-v-center legend";
                a.href = legendUrl;
                a.target = "_blank";
                a.text = "圖例";
                widgetContent.append(a);
            } else if (selectedObj.id == "SoilLiquefaction2") {
                let img = document.createElement("img");
                img.className = "ov-widget-BuildingOverlay-v-center legend";
                img.style.margin = "0 auto";
                img.src = "./img/SoilLiquefaction2Legend.png";
                widgetContent.append(img);
            }
        });

        let closeBtn = document.querySelectorAll(".ov-widget-BuildingOverlay-main .ov-widget-header .ov-ui-button")[1];
        closeBtn.addEventListener("mouseup", () => {
            let modelSet = window.main.OView.findLayer("nangang");
            if (modelSet != null) {
                window.main.OView.removeLayer(modelSet);
            }
        });

    }
    showGmlPipeline() {
        let widget = new window.ov.Widget.GmlPipeline({ view: window.main.OView, urlTemplate: window.TERRAIN_SERVER.URLTemplate }); //選擇要綁定的terrainview並初始化介接GMLe管線操作Widget。
        widget._WidgetUI._PosX = 145;
        document.querySelector(".ov-widget-gmlPipeline-main").style.left = "145px";
        this.sidebarSwitch();
        window.main.OView.terrainAlpha = 0.3;
        let widgetContent = document.querySelector(".ov-widget-gmlPipeline-container");
        if (document.querySelector(".set-terrain") != null) {
            document.querySelector(".set-terrain").remove();
        }
        let setTerrain = document.createElement("div");
        setTerrain.className = "set-terrain";
        setTerrain.innerHTML = '<a class="example-file" href="src/gmlPipeline.zip">範例檔案</a><p>地形透視：30%</p><input type="range" min="0" max="100" step="1" value="30" id="gmlTerrainAlpha">';
        widgetContent.prepend(setTerrain);
        document.getElementById("gmlTerrainAlpha").addEventListener("change", (e) => {
            let val = e.target.value;
            document.querySelector(".set-terrain p").innerText = `地形透視：${val}%`;
            window.main.OView.terrainAlpha = val/100;
        });
    }
    showLandAPI() {
        let widget = new window.ov.Widget.LandAPI({
            view: window.main.OView,
            urlTemplate: window.TERRAIN_SERVER.URLTemplate
        });
        widget._WidgetUI._PosX = 145;
        document.querySelector(".ov-widget-LandApi-main").style.left = "145px";
        this.sidebarSwitch();

        window.main.OView.gotoCamera(new window.ov.Camera(
            new window.GeoPoint(121.72172099819517, 25.111938318314614, 24000),
            new window.Geo3DPoint(0, 0, -1),
            new window.Geo3DPoint(0, 1, 0)
        ), false); // 基隆
    }
    render(){
        const isWidgetListOpen = this.props.isWidgetListOpen;        
        const sideMenuCSS ={
            overflow : 'inherit',
            transform : isWidgetListOpen?'translate3d(0, 0, 0)':'translate3d(-120%, 0, 0)',
            width : '480px'
        };
        const titleCSS = {
            margin: '10px 10px 10px 10px' 
        };
        return(
            <div>
                <div className="ts left vertical sidebar visible menu" id="sideMenu" style={sideMenuCSS}>
                    <div className="ts grid">
                        <div className="row" id="sideMenuTitle">
                            <div className="fourteen wide column">
                                <h4 className="ts header" style={titleCSS}>
                                    <i className="block layout icon"></i>
                                    <div className="content">
                                        Widget
                                    </div>
                                </h4>
                            </div>
                            <div className="two wide column" id="closeIconColumn">
                                <i className="remove icon" id="closeIcon" onClick={(e)=>this.sidebarSwitch(e)}></i>                        
                            </div>
                        </div>
                    </div>
                    <div className="widget-list">
                        <div className="ts four column very narrow container grid" style={{ margin: "10px 20px" }}>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowBaseLayer" onClick={()=>this.showBaseLayer()}>
                                    <i className="map icon"></i><br/>
                                    <span>底圖置換</span>
                                </button>
                            </div>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowSatellite" onClick={()=>this.showSatellite()}>
                                    <i className="grav icon"></i><br/>
                                    <span>衛星展示</span>
                                </button>
                            </div>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowFPS" onClick={() => this.showFPS()}>
                                    <i className="eye icon"></i><br/>
                                    <span>FPS監控</span>
                                </button>
                            </div>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowDTM" onClick={()=>this.showDTM()}>
                                    <i className="globe icon"></i><br/>
                                    <span>DTM加值</span>
                                </button>
                            </div>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowWeather" onClick={() => this.showWeather()}>
                                    <i className="sun icon"></i><br/>
                                    <span>氣象觀測</span>
                                </button>
                            </div>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowPipeline" onClick={() => this.showPipeline()}>
                                    <i className="configure icon"></i><br/>
                                    <span>地下管線</span>
                                </button>
                            </div>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowTrack" onClick={() => this.showTrack()}>
                                    <i className="plane icon"></i><br/>
                                    <span>飛航管理</span>
                                </button>
                            </div>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowSeaBed" onClick={() => this.showSeaBed()}>
                                    <i className="area chart icon"></i><br/>
                                    <span>海底地形</span>
                                </button>
                            </div>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowSensorThings" onClick={() => this.showSensorThings()}>
                                    <i className="mixcloud icon"></i><br />
                                    <span style={{fontSize: "9pt"}}>SensorThings</span>
                                </button>
                            </div>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowHouseDisplay" onClick={() => this.showHouseDisplay()}>
                                    <i className="home icon"></i><br />
                                    <span style={{fontSize: "9pt"}}>既有成屋展示</span>
                                </button>
                            </div>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowHouseInspection" onClick={() => this.showHouseInspection()}>
                                    <i className="icons">
                                        <i className="home icon"></i>
                                        <i className="corner check icon"></i>
                                    </i><br />
                                    <span style={{fontSize: "9pt"}}>既有成屋檢核</span>
                                </button>
                            </div>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowOGCLayer" onClick={() => this.showOGCLayer()}>
                                    <i className="building icon"></i><br />
                                    <span style={{fontSize: "9pt"}}>介接OGC圖層</span>
                                </button>
                            </div>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowSocioeconomic" onClick={() => this.showSocioeconomic()}>
                                    <i className="bar chart icon"></i><br />
                                    <span style={{fontSize: "9pt"}}>社會經濟統計</span>
                                </button>
                            </div>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowKML" onClick={() => this.showKML()}>
                                    <i className="road icon"></i><br />
                                    <span style={{fontSize: "9pt"}}>道路養護KML</span>
                                </button>
                            </div>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowMultiWindow" onClick={() => this.showMultiWindow()}>
                                    <i className="columns icon"></i><br />
                                    <span style={{fontSize: "9pt"}}>多視窗模式</span>
                                </button>
                            </div>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowBuildingOverlay" onClick={() => this.showBuildingOverlay()}>
                                    <i className="icons">
                                        <i className="building outline icon"></i>
                                        <i className="corner map icon"></i>
                                    </i><br />
                                    <span style={{fontSize: "9pt"}}>簡易建物套疊</span>
                                </button>
                            </div>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowGmlPipeline" onClick={() => this.showGmlPipeline()}>
                                    <span class="material-symbols-outlined" style={{lineHeight: 0, top: "7px"}}>valve</span>
                                    <span style={{fontSize: "9pt"}}>GML管線工具</span>
                                </button>
                            </div>
                            <div className="column">
                                <button className="ts basic icon button" id="btnshowLandAPI" onClick={() => this.showLandAPI()}>
                                    <i className="icons">
                                        <i className="university icon"></i>
                                        <i className="corner database icon"></i>
                                    </i><br />
                                    <span style={{fontSize: "9pt"}}>介接地政整合資料庫</span>
                                </button>
                            </div>
                        </div>
                    </div>                    
                </div>
            </div>            
        );
    }
}
export default WidgetListSidebar;
